module.exports = __webpack_public_path__ + "media/images/bnr_referral_sp-af71f3cfd3dc553d393b9dc4eb22e696.jpg";